import { AfterContentInit, AfterViewInit, Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaryComponentHelper } from '../../util/bary-component-helper';
import { CommonModule } from '@angular/common';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { TranslateModule } from '@ngx-translate/core';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-card',
  templateUrl: './bary-card.component.html',
  styleUrls: ['./bary-card.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MDBBootstrapModulesPro, TranslateDirective, TranslateModule, BaryIconComponent],
})
export class BaryCardComponent implements OnInit, AfterViewInit {
  @Input() titleKey?: string;
  @Input() titleValue?: any;
  @Input() title?: string;
  @Input() icon?: string;
  @Input() tooltip?: string;
  @Input() borderActive = false;
  @Input() withSwitch = false;
  @Input() checked = false;
  @Input() size: 'md' | 'sm' = 'md';
  @Input() id = BaryComponentHelper.makeId();
  @Input() withCollapse = false;
  @Input() startAsCollapsed = false;
  @Input() disabled = false;
  @Input() disabledMessage = '';
  @Input() cascade: boolean = false;

  @Output() switchChangeEvent = new EventEmitter();

  @ViewChild('cardBody') cardBody!: ElementRef;

  public _collapseState = false;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public ngOnInit(): void {
    if (this.withCollapse && this.startAsCollapsed) {
      this._collapseState = true;
    }
  }

  public ngAfterViewInit(): void {
    if (this.cardBody?.nativeElement?.firstElementChild) this.cardBody.nativeElement.classList.add('card-body');
  }

  public handleSwitchChange($event: boolean): void {
    this.switchChangeEvent.emit($event);
  }

  public handleCollapse(): void {
    if (this.withCollapse) {
      this._collapseState = !this._collapseState;
    }
  }
}
